import React from 'react';
import livekasmbg from "../../../../../assets/images/livekasmbg.png";
class Image extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isError: false
    }
  }

  render() {
    return <img {...this.props} onError={() => this.setState({ isError: true })} src={!this.state.isError ? this.props.src : livekasmbg} />
  }
}

export default Image;


// WEBPACK FOOTER //
// ./src/views/User/UserDashboard/ListKasms/image.js